import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CheckInKioskUiModule } from '@frontend/check-in-kiosk/ui/src';
import { CheckInRoutedComponent } from './check-in-kiosk-feature-check-in-routed.component';

@NgModule({
  imports: [CommonModule, CheckInKioskUiModule],
  declarations: [CheckInRoutedComponent],
  exports: [CheckInRoutedComponent],
})
export class CheckInKioskFeatureCheckInModule {}
